import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core"
import Save from "../../../../Assets/img/svg/save.svg"
import Cancel from "../../../../Assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../Assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../helpers/endpointService"
import del from "../../../../Assets/img/svg/Del.svg"
import Autocomplete from "react-autocomplete";
import { putshipinchargeinfo } from "../../../../actions/AddNewShipAction";
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import { json } from "react-router-dom";

class AddIC extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fieldInspectorName: [],
            inspectorEmail: "",
            clientValue: "",
            clientName: [],
            fieldInspectorList: [],
            clientList: [],
            FieldInspectorUserId: 0,
            clietUserId: 0,
            User_Table: [],
            isMobile: false,
            menu: true,
            isEdit: false,
            isAccessControl: false,
            isfieldInspectorExist: false,
            isclientExist: false,
            isshipError: false,
            isyardError1: false,
            isyardError2: false,
            issupervisorError1: false,
            issupervisorError2: false,
            cancel: false,
            ShipName: "New Ship",
            AccessToken: "",
            ShipId: 0,
            addData: {
                "ShipId": 0,
                "ClientId": "",
                "ClientName": "",
                "ClientMail": "",
                "FieldInspectorId": "",
                "FieldInspectorName": " ",
                "FieldInspectorMail": " ",
                "CreatedBy": "",
                "ModifiedBy": "",
                "SortBy": '',
                "SortOrder": 'asc'
            },
            fieldInspectorData: {
                "PageNumber": 1,
                "PageSize": 1000,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "ContactNumber": "",
                "Location": null,
                "Status": "",
                "RoleId": 2,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ShipIds": [0],
                "ShipUserList": [],
                "SortBy": 'email',
                "SortOrder": 'asc'
            },
            clientData: {
                "PageNumber": 1,
                "PageSize": 1000,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "ContactNumber": "",
                "Location": null,
                "Status": "",
                "RoleId": 3,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ShipIds": [0],
                "ShipUserList": [],
                "SortBy": 'email',
                "SortOrder": 'asc'
            }
        }
        this.renderfieldInspectorNames = this.renderfieldInspectorNames.bind(this);
        this.renderclientNames = this.renderclientNames.bind(this);
    };

    async componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        localStorage.getItem("UserRoles")?.toLowerCase() == "admin" ? this.state.isAccessControl = false : this.state.isAccessControl = true;
        window.location.pathname === "/incharge/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.AccessToken = JSON.parse(localStorage.getItem("currentUser")).accessToken;
        this.state.ShipName = localStorage.getItem("ShipName");
        this.state.addData.CreatedBy = localStorage.getItem("UserRoles");
        await this.getFieldInspectorDetails(this.state.fieldInspectorData);
        await this.getClientDetails(this.state.clientData);
        this.setState({})
        if (this.state.isEdit == false) {
            if (localStorage.getItem("addeditid") != null) {
                this.state.addData.ShipId = localStorage.getItem("addeditid");
                await this.getshipbasicinfo(localStorage.getItem("addeditid"))
            }
        }
        if (this.state.isEdit == true) {
            this.state.addData.ShipId = localStorage.getItem("DashId");
            await this.getshipbasicinfo(localStorage.getItem("DashId"))
        }
        this.props.dispatch({ type: "USER_TABLE", data: [] });
    }

    getClientDetails = (data) => {
        let apiUrl = API.USER_MANAGEMENT + "?Name=" + data.Name + "&Email=" + data.Email + "&RoleId=" + data.RoleId + "&ContactNumber=" + data.ContactNumber + "&Location=" + data.Location + "&ShipIds=" + data.ShipIds + "&SortBy=" + data.SortBy + "&SortOrder=" + data.SortOrder + "&PageNumber=" + data.PageNumber + "&PageSize=" + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response?.data?.Users.length > 0) {
                        response?.data?.Users.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.clientList.push(listItem);
                                this.state.clientName.push(i.Name);
                            }
                            this.setState({})
                        })
                        this.setState({})
                        if (this.state.addData.ClientName != "") {
                            let data1 = this.state.clientList.filter(x => x.Email === this.state.addData.ClientMail)
                            this.state.clietUserId = data1[0].UserId;
                            this.state.clientValue = data1[0].compain;
                            this.setState({})
                        }
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    getFieldInspectorDetails = (data) => {
        let apiUrl = API.USER_MANAGEMENT + "?Name=" + data.Name + "&Email=" + data.Email + "&RoleId=" + data.RoleId + "&ContactNumber=" + data.ContactNumber + "&Location=" + data.Location + "&ShipIds=" + data.ShipIds + "&SortBy=" + data.SortBy + "&SortOrder=" + data.SortOrder + "&PageNumber=" + data.PageNumber + "&PageSize=" + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response?.data?.Users.length > 0) {
                        response?.data?.Users.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.fieldInspectorList.push(listItem);
                                this.state.fieldInspectorName.push(i.Name);
                            }
                            this.setState({})
                        })
                        this.setState({})
                        if (this.state.addData.FieldInspectorName != "") {
                            let data = this.state.fieldInspectorList.filter(x => x.Email === this.state.addData.FieldInspectorMail);
                            this.state.FieldInspectorUserId = data[0].UserId;
                            this.state.inspectorEmail = data[0].compain
                            this.setState({})
                        }
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    getshipbasicinfo = async (data) => {
        let apiUrl = API.GET_SHIP + "/id?id=" + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {

                    this.state.addData.ClientMail = response?.data?.ShipIncharge?.ClientMail;
                    this.state.addData.ClientName = response?.data?.ShipIncharge?.ClientName;
                    this.state.addData.ClientId = response?.data?.ShipIncharge?.ClientId;
                    this.state.addData.FieldInspectorId = response?.data?.ShipIncharge?.FieldInspectorId;
                    this.state.addData.FieldInspectorName = response?.data?.ShipIncharge?.FieldInspectorName;
                    this.state.addData.FieldInspectorMail = response?.data?.ShipIncharge?.FieldInspectorMail;
                    this.setState({})
                    if (this.state.addData.ClientName != "") {
                        let data1 = this.state.clientList.filter(x => x.Email === this.state.addData.ClientMail)
                        this.state.clietUserId = data1[0].UserId;
                        this.state.clientValue = data1[0].compain;
                        this.setState({})
                    }

                    if (this.state.addData.FieldInspectorMail != "") {
                        let data = this.state.fieldInspectorList.filter(x => x.Email === response?.data?.ShipIncharge?.FieldInspectorMail);
                        this.state.FieldInspectorUserId = data[0].UserId;
                        this.state.inspectorEmail = data[0].compain
                        this.setState({})
                    }

                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            });

    };
    getShipDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {

                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.fieldInspectorList.push(listItem);
                                this.state.fieldInspectorName.push(i.Name);
                            }
                            this.setState({})
                        })

                    }

                }
            })
    }
    getYardDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, YardName: i.YardName, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.yardInchargeList.push(listItem);
                                this.state.yardInchargeName.push(i.Name);
                            }

                            this.setState({})
                        })

                    }
                }
            })
    }
    getSupervisorDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;

        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, Company: i.MonitoringCompany, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.supervisorList.push(listItem);
                                this.state.supervisorName.push(i.Name);

                            }
                            this.setState({})
                        })

                    }
                }

            })
    }
    renderfieldInspectorNames = (state, val) => {
        return state?.shipOwnerName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    renderclientNames = (state, val) => {
        return state?.SuperVisorName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#IC .MuiListItemText-primary").removeClass("fw-bolder")
        $("#ICL").removeClass("active-color")
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditship");
            }
            else {
                this.props.navigate("/sidebaraddship");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#InCharge1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#InCharge").removeClass("d-none");
        $("#InCharge").addClass("d-block");
        $("#IC .MuiListItemText-primary").addClass("fw-bolder")
        $("#ICL").addClass("active-color")
    }


    fieldInspectorOnchange = (e) => {
        this.state.inspectorEmail = e.target.value;
        this.setState({});
    }

    handleAutocompleteOnchange = (e, obj, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node === "FieldInspectorName") {
            let type = this.state.fieldInspectorList.filter((i) => i.UserId === parseInt(obj.UserId))
            if (type.length == 1) {
                this.state.inspectorEmail = e;
                this.state.FieldInspectorUserId = type[0].UserId
                this.state.addData.FieldInspectorName = type[0].Name
                this.state.addData.FieldInspectorMail = type[0].Email
                this.setState({})
            }
            else {
                this.state.inspectorEmail = "";
                this.state.FieldInspectorUserId = 0
                this.state.addData.FieldInspectorName = ""
                this.state.addData.FieldInspectorMail = ""
                this.setState({})
            }
        } else if (node === "ClientName") {
            let type = this.state.clientList.filter((i) => i.UserId === parseInt(obj.UserId))
            if (type.length == 1) {
                this.state.clientValue = e;
                this.state.clietUserId = type[0].UserId;
                this.state.addData.ClientName = type[0].Name
                this.state.addData.ClientMail = type[0].Email;
                this.setState({})
            }
            else {
                this.state.clientValue = "";
                this.state.clietUserId = 0;
                this.state.addData.ClientName = "";
                this.state.addData.ClientMail = "";
                this.setState({})
            }
        }
        this.setState({})
    }

    handleInputChange = (e, node) => {

        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node === "FieldInspectorName") {
            let type = this.state.fieldInspectorList.filter((i) => i.UserId === parseInt(e.target.value))
            if (type.length == 1) {
                this.state.FieldInspectorUserId = type[0].UserId
                this.state.addData.FieldInspectorName = type[0].Name
                this.state.addData.FieldInspectorMail = type[0].Email
                this.setState({})
            }
            else {
                this.state.FieldInspectorUserId = 0
                this.state.addData.FieldInspectorName = ""
                this.state.addData.FieldInspectorMail = ""
                this.setState({})
            }
        } else if (node === "ClientName") {
            let type = this.state.clientList.filter((i) => i.UserId === parseInt(e.target.value))
            if (type.length == 1) {
                this.state.clietUserId = type[0].UserId;
                this.state.addData.ClientName = type[0].Name
                this.state.addData.ClientMail = type[0].Email;
                this.setState({})
            }
            else {
                this.state.clietUserId = 0;
                this.state.addData.ClientName = "";
                this.state.addData.ClientMail = "";
                this.setState({})
            }
        }
        this.setState({})
    };

    handleSelectChange = (e, node) => {
        if (node === "FieldInspectorName" && e !== "") {

            this.state.addData.FieldInspectorName = e;
            this.state.fieldInspectorList.map((item, index) => {
                if (item.Name === this.state.addData.FieldInspectorName) {
                    this.state.isfieldInspectorExist = true;
                    this.state.addData.FieldInspectorMail = item.Email
                }
            })
        } else if (node === "ClientName" && e !== "") {
            this.state.addData.ClientName = e;
            this.state.clientList.map((item, index) => {
                if (item.Name === this.state.addData.ClientName) {
                    this.state.isclientExist = true;
                    this.state.addData.ClientMail = item.Email;
                    this.state.addData.ClientName = item.YardName
                }
            })
        }

        this.setState({})
    }

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    Save = () => {
        if (this.state.addData.ShipId !== 0 || this.state.addData.ShipId !== undefined || this.state.addData.ShipId !== null) {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.setState({ cancel: false })
            this.props.dispatch(putshipinchargeinfo(this.state.addData, this.state.AccessToken))
        } else {
            this.props.navigate(`/incharge/add`)
        }
    };

    fieldValidate = () => {
        const { FieldInspectorMail, FieldInspectorName, ClientMail, ClientName } = this.state.addData
        let errors = {};
        this.state.isshipError = false;
        this.state.isyardError1 = false;
        this.state.isyardError2 = false;
        this.state.issupervisorError1 = false;
        this.state.issupervisorError2 = false;
        if (FieldInspectorName !== null && FieldInspectorName !== "") {
            if (FieldInspectorMail === "") {
                errors.FieldInspectorMail = "Email is required"
                this.state.isshipError = true;
            }
            else {
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                let IsValidEmail = filter.test(FieldInspectorMail.toLowerCase());
                if (!IsValidEmail) {
                    errors.FieldInspectorMail = "please enter the valid email"
                    this.state.isshipError = true;
                }
            }
            this.setState({})
        }
        if (ClientName !== null && ClientName !== "") {
            if (ClientMail === "") {
                errors.ClientMail = "Yard Incharge Email is required"
                this.state.isyardError1 = true;
            }
            else {
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                let IsValidEmail = filter.test(FieldInspectorMail.toLowerCase());
                if (!IsValidEmail) {
                    errors.ClientMail = "please enter the valid email"
                    this.state.isyardError1 = true;
                }
            }
            if (ClientName === "") {
                errors.ClientName = "Recycling Yard Name is required"
                this.state.isyardError2 = true
            }
            this.setState({})
        }
        if (FieldInspectorName === "" && ClientName === "") {
            errors.empty = "All fields are empty"
        }
        return errors
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/shiplist`)
    };

    renderProjectClientId = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };


    renderfieldInspectorList = (state, val) => {
        return state?.compain?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    render() {
        const { isEdit, isAccessControl } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"InCharge" + "1"} className='textNaviIcon f-size-13' primary={this.state.isEdit ? "Edit Ship" : "New Ship"} />
                                            <NavigateNextIcon id="InCharge" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">In Charge</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="mt-130 ml-auto scroll-hide" id="Addincharge" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75, height: this.state.isMobile ? window.innerHeight - 125 : window.innerHeight - 65 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} disabled={isAccessControl ? true : false} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} disabled={isAccessControl ? true : false} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div  style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1"> {this.state.ShipName ? this.state.ShipName : "New Ship"} </h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Field Inspector Name&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isAccessControl ?
                                        // <select
                                        //     fullWidth
                                        //     disabled
                                        //     value={this.state.FieldInspectorUserId}
                                        //     style={{ height: "40px" }}
                                        //     className="form-control border-radius form-select view-color"
                                        // >
                                        //     <option value={0}>Select Field Inspector Name</option>
                                        //     {this.state.fieldInspectorList &&
                                        //         this.state.fieldInspectorList.map((i, ind) => {
                                        //             return <option value={i.UserId}>{i.compain}</option>
                                        //         })}
                                        // </select>
                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                //   contentEditable={true}
                                                value={this.state.inspectorEmail}
                                                inputProps={{
                                                    placeholder: "Field Inspector Name",
                                                }}
                                                items={this.state.fieldInspectorList ?? []}
                                                getItemValue={(item) => item.compain}
                                                // shouldItemRender={this.renderfieldInspectorList.bind(
                                                //     this
                                                // )}
                                                // renderMenu={(item) => (
                                                //     <div className="dropdowns d-block">{item}</div>
                                                // )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{
                                                                height: 32,
                                                                fontSize: 12,
                                                                color: "#000000",
                                                            }}
                                                            disabled
                                                        />
                                                    );
                                                }}
                                                // renderItem={(item, isHighlighted) => (
                                                //     <div
                                                //         className={`items 
                                                //         ${isHighlighted
                                                //                 ? "selected-items"
                                                //                 : ""
                                                //             }`}
                                                //     >
                                                //         {item.compain}
                                                //     </div>
                                                // )}
                                                // onChange={(e, newValue) =>
                                                //     this.fieldInspectorOnchange(e, newValue)
                                                // }
                                                // onSelect={(e, newValue) =>
                                                //     this.handleAutocompleteOnchange(e, newValue, "FieldInspectorName")
                                                // }
                                            />
                                        </div>
                                        :
                                        // <select
                                        //     fullWidth
                                        //     value={this.state.FieldInspectorUserId}
                                        //     style={{ height: "40px" }}
                                        //     className="form-control border-radius form-select"
                                        //     onChange={(e) => { this.handleInputChange(e, "FieldInspectorName") }}
                                        // >
                                        //     <option value={0}>Select Field Inspector Name</option>
                                        //     {this.state.fieldInspectorList &&
                                        //         this.state.fieldInspectorList.map((i, ind) => {
                                        //             return <option value={i.UserId}>{i.compain}</option>
                                        //         })}
                                        // </select>
                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.inspectorEmail}
                                                inputProps={{
                                                    placeholder: "Field Inspector Name",
                                                }}
                                                items={this.state.fieldInspectorList ?? []}
                                                getItemValue={(item) => item.compain}
                                                shouldItemRender={this.renderfieldInspectorList.bind(
                                                    this
                                                )}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block">{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{
                                                                height: 32,
                                                                fontSize: 12,
                                                                color: "#000000",
                                                            }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                                        ${isHighlighted
                                                                ? "selected-items"
                                                                : ""
                                                            }`}
                                                    >
                                                        {item.compain}
                                                    </div>
                                                )}
                                                onChange={(e, newValue) =>
                                                    this.fieldInspectorOnchange(e, newValue)
                                                }
                                                onSelect={(e, newValue) =>

                                                    this.handleAutocompleteOnchange(e, newValue, "FieldInspectorName")
                                                }

                                            />
                                        </div>
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Field Inspector Mail ID&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.FieldInspectorMail}
                                        onChange={(e) => { this.handleInputChange(e, "FieldInspectorMail") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />

                                </div>
                            </div>
                            {localStorage.getItem("UserRoles") == "FieldInspector" ? <></> :
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0" : " form-group m-0 text-right float-end"}>Client Name&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        {isAccessControl ?
                                            // <select
                                            //     fullWidth
                                            //     disabled
                                            //     value={this.state.clietUserId}
                                            //     style={{ height: "40px" }}
                                            //     className="form-control border-radius form-select view-color"
                                            // >
                                            //     <option value={0}>Select Client Name</option>
                                            //     {this.state.clientList &&
                                            //         this.state.clientList.map((i, ind) => {
                                            //             return <option value={i.UserId}>{i.compain}</option>
                                            //         })}
                                            // </select>
                                            <div className="autocomplete-wrappers">
                                                <Autocomplete
                                                    contentEditable={true}
                                                    value={this.state.clientValue}
                                                    inputProps={{
                                                        placeholder: "Client Name",
                                                    }}
                                                    items={this.state.clientList ?? []}
                                                    getItemValue={(item) => item.compain}
                                                    // shouldItemRender={this.renderProjectClientId.bind(
                                                    //     this
                                                    // )}
                                                    // renderMenu={(item) => (
                                                    //     <div className="dropdowns d-block">{item}</div>
                                                    // )}
                                                    renderInput={(props) => {
                                                        return (
                                                            <input
                                                                className="form-control border-radius"
                                                                id="exampleFormControlInput1"
                                                                {...props}
                                                                style={{
                                                                    height: 32,
                                                                    fontSize: 12,
                                                                    color: "#000000",
                                                                }}
                                                                disabled
                                                            />
                                                        );
                                                    }}
                                                    // renderItem={(item, isHighlighted) => (
                                                    //     <div
                                                    //         className={`items 
                                                    //     ${isHighlighted
                                                    //                 ? "selected-items"
                                                    //                 : ""
                                                    //             }`}
                                                    //     >
                                                    //         {item.compain}
                                                    //     </div>
                                                    // )}
                                                    // onChange={(e, newValue) =>
                                                        // this.fieldInspectorOnchange(e, newValue)
                                                    // }
                                                    // onSelect={(e, newValue) =>
                                                        // this.handleAutocompleteOnchange(e, newValue, "FieldInspectorName")
                                                    // }

                                                />
                                            </div>
                                            :
                                            // <select
                                            //     fullWidth
                                            //     value={this.state.clietUserId}
                                            //     style={{ height: "40px" }}
                                            //     className="form-control border-radius form-select"
                                            //     onChange={(e) => { this.handleInputChange(e, "ClientName") }}
                                            // >
                                            //     <option value={0}>Select Client Name</option>
                                            //     {this.state.clientList &&
                                            //         this.state.clientList.map((i, ind) => {
                                            //             return <option value={i.UserId}>{i.compain}</option>
                                            //         })}
                                            // </select>
                                            <div className="autocomplete-wrappers">
                                                <Autocomplete
                                                    contentEditable={true}
                                                    value={this.state.clientValue}
                                                    inputProps={{
                                                        placeholder: "Client Name",
                                                    }}
                                                    items={this.state.clientList ?? []}
                                                    getItemValue={(item) => item.compain}
                                                    shouldItemRender={this.renderProjectClientId.bind(
                                                        this
                                                    )}
                                                    renderMenu={(item) => (
                                                        <div className="dropdowns d-block">{item}</div>
                                                    )}
                                                    renderInput={(props) => {
                                                        return (
                                                            <input
                                                                className="form-control border-radius"
                                                                id="exampleFormControlInput1"
                                                                {...props}
                                                                style={{
                                                                    height: 32,
                                                                    fontSize: 12,
                                                                    color: "#000000",
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                    renderItem={(item, isHighlighted) => (
                                                        <div
                                                            className={`items 
                                                        ${isHighlighted
                                                                    ? "selected-items"
                                                                    : ""
                                                                }`}
                                                        >
                                                            {item.compain}
                                                        </div>
                                                    )}
                                                    onChange={(e) =>
                                                        // this.handleProjectNameSearchChange(e, "Email")
                                                        this.setState({ clientValue: e.target.value })}
                                                    onSelect={(e, newValue) =>
                                                        // this.handleProjectNameSelectChange(e, "Email")
                                                        this.handleAutocompleteOnchange(e, newValue, "ClientName")
                                                    }

                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Client Email ID&nbsp;:
                                        </label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.ClientMail}
                                            onChange={(e) => { this.handleInputChange(e, "ClientMail") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        />

                                    </div>

                                </div>
                            }
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        User_Table: state.UserReducer.User_Table,

    };
}

AddIC.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddIC))
);